import { render, staticRenderFns } from "./CmgRecentAndFavoriteOrdersMini.vue?vue&type=template&id=42d0d256&scoped=true&lang=pug"
import script from "./cmg-recent-and-favorite-orders-mini.ts?vue&type=script&lang=ts&external"
export * from "./cmg-recent-and-favorite-orders-mini.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRecentAndFavoriteOrdersMini.vue?vue&type=style&index=0&id=42d0d256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d0d256",
  null
  
)

export default component.exports